/**
 * @generated SignedSource<<0adca7800f98ac5584e7901ffaa7933e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionApprovalsFragment$data = {
  readonly anySubmission: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"SubmissionsCompetitionApprovalsFragment">;
  readonly " $fragmentType": "CompetitionApprovalsFragment";
};
export type CompetitionApprovalsFragment$key = {
  readonly " $data"?: CompetitionApprovalsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionApprovalsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "needsApproval"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionApprovalsFragment",
  "selections": [
    {
      "alias": "anySubmission",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "SubmissionConnection",
      "kind": "LinkedField",
      "name": "submissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SubmissionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "submissions(first:1)"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "needsApproval",
          "variableName": "needsApproval"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SubmissionsCompetitionApprovalsFragment"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};

(node as any).hash = "0e0d06f67c29a799f0221013b16bdf44";

export default node;
